<!-- 详情组件 -->
<template>
  <div class="main-wrap">
    <avue-crud
      ref="params"
      :data="tableList"
      :option="listOpt"
      :page="page"
      :table-loading="loading"
      @size-change="sizeChange"
      @current-change="currentChange"
      @search-change="searchChange"
      @search-reset="resetList"
    >
      <template slot="dayTimeSearch">
        <d-link-date
          :min="-365"
          :max="0"
          :space="31"
          :startConfig="startConfig"
          :endConfig="endConfig"
          :start-time.sync="slotParams.startTime"
          :end-time.sync="slotParams.endTime"
        />
      </template>
      <template slot="sessionIdSearch">
        <!-- 插槽,限制只能输入数字 -->
        <el-input
          v-model="slotParams.sessionId"
          oninput="value=value.replace(/[^\d]/g,'')"
          clearable
        ></el-input>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" :title="$lang('查看')" @click="handleView(row)">
          <i class="iconfont iconchakanxiangqing" />
        </el-button>
      </template>
    </avue-crud>
    <!-- 会话详情 -->
    <chatDrawer :drawerShow.sync="drawerShow" :drawerList="drawerList" />
  </div>
</template>

<script>
import mixin from '@mixins/mixin';
import exportMixns from '@/common/mixin/exportMixns';
import chatDrawer from '../chat-drawer';
import { RESPONSE_CODE } from '@public/http/config';
import { sessionHistoryApi } from '../../session-history/pool';
import { serviceProviderApi } from '../../service-provider/pool';
import { customerServiceApi } from '../../customer-service/pool';
import { incomingLineApi } from '../../incoming-line/pool';
import { commonFun } from '@public/utils/common';
import { DICT } from '@/common/utils/dict';
const setConfig = {
  format: 'yyyy-MM-dd',
  type: 'date',
  valueFormat: 'yyyy-MM-dd'
};
const baseParams = {
  sessionId: '',
  startTime: commonFun.GetTodayDate(-6, false)[0],
  endTime: commonFun.GetTodayDate(0, false)[1]
};
export default {
  name: 'DetailsComp',
  mixins: [mixin, exportMixns],
  components: {
    chatDrawer
  },
  data() {
    return {
      isShowFirst: true,
      COM_HTTP: incomingLineApi,
      defaultTime: [
        commonFun.GetTodayDate(-6, false)[0],
        commonFun.GetTodayDate(0, false)[1]
      ],
      agentOptions: null, // 客服姓名
      serviceOptions: null, // 服务商
      drawerShow: false,
      drawerList: [],
      startConfig: {
        ...setConfig
      },
      endConfig: {
        ...setConfig
      },
      slotParams: {
        ...baseParams
      },
      reportTotalDetailType: '',
      rowData: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getParameter();
      this.getAgentOptions();
      this.getServiceOptions();
    },
    // 获取参数
    getParameter() {
      const routerName = this.$route.name;
      const strData = window.localStorage.getItem(routerName) || null;
      const dataJson = strData ? JSON.parse(strData) : null;
      if (!dataJson) return;
      window.localStorage.removeItem(routerName);
      const { formatDate, serviceId, channelCode, agentId, serviceNetworkId } = dataJson;
      const [startTime, endTime] = formatDate.split(' ');
      this.slotParams.startTime = startTime;
      this.slotParams.endTime = endTime || startTime;
      this.reportTotalDetailType = dataJson.reportTotalDetailType;
      this.slotParams.serviceId = serviceId;
      this.slotParams.skillGroupCode = channelCode;
      this.slotParams.agentIdList = agentId ? [agentId] : []
      this.slotParams.serviceNetworkIdList = serviceNetworkId ? [serviceNetworkId] : []
      this.rowData = dataJson;
      this.searchFun();
    },
    // 客服姓名
    async getAgentOptions() {
      const { data } = await customerServiceApi.queryAgentOptions();
      if (data) {
        this.agentOptions = data;
      }
    },
    // 获取服务商选项
    async getServiceOptions() {
      const { data } = await serviceProviderApi.queryProvider();
      if (data) {
        this.serviceOptions = data;
      }
    },
    // 查看
    async handleView(row) {
      const { code, data } = await sessionHistoryApi.queryDetail(row.id);
      if (code === RESPONSE_CODE.SUCCESS) {
        this.drawerList = data;
      }
      this.drawerShow = true;
    },
    // 清空
    resetList() {
      for (const key in this.$refs?.params?.searchForm) {
        this.$refs.params.searchForm[key] = '';
      }
      const { serviceNetworkId, serviceNetworkName } = this.rowData;
      // 如果是网点页面
      if (serviceNetworkId && serviceNetworkName) {
        this.$refs.params.searchForm.serviceNetworkIdList = serviceNetworkId ? [serviceNetworkId] : []
        this.$refs.params.searchForm.serviceNetworkName = serviceNetworkName;
      }
      this.slotParams = {
        ...baseParams
      };
    },
    // 查询参数混入
    setSearchParams() {
      return {
        ...this.slotParams,
        reportTotalDetailType: this.reportTotalDetailType
      };
    }
  },
  computed: {
    listOpt() {
      const that = this;
      return {
        menu: true,
        ignorePermission: true,
        menuWidth: 50,
        exportBtn: false,
        column: [
          {
            label: '统计日期',
            prop: 'dayTime',
            search: true,
            searchslot: true,
            hide: true
          },
          {
            label: '客服姓名',
            prop: 'agentIdList',
            type: 'select',
            search: true,
            dicData: that.agentOptions,
            props: {
              label: 'agentName',
              value: 'id'
            },
            width: 300,
            hasAll: false,
            filterable: true,
            searchFilterable: true,
            searchMmultiple: true,
            hide: true,
            tpyeformat: ({ agentName, account }) => `${agentName} | ${account}`,
            formatter({ agentName }) {
              return agentName;
            },
            searchDefault: this.rowData?.agentId ? [this.rowData?.agentId] : ''
          },
          {
            label: '服务商',
            prop: 'serviceId',
            type: 'select',
            search: true,
            hide: true,
            dicData: that.serviceOptions,
            props: {
              label: 'serviceName',
              value: 'id'
            },
            searchDefault: this.rowData?.serviceId || ''
          },
          {
            label: '渠道',
            prop: 'skillGroupCode',
            viewProp: 'channelName',
            search: true,
            searchClearable: true,
            type: 'select',
            dicData: DICT.F_channelList,
            searchDefault: this.rowData?.channelCode || '',
            hasAll: false
          },
          {
            label: '日期',
            prop: 'formatDate'
          },
          {
            label: '会话ID',
            prop: 'sessionId',
            minWidth: 180,
            search: true,
            searchslot: true,
            formatter({ id }) {
              return id;
            }
          },
          {
            label: '客户名称',
            prop: 'customerName'
          },
          {
            label: '进线开始时间',
            prop: 'customerIncomingTime'
          },
          {
            label: '进线结束时间',
            prop: 'sessionEndTime'
          },
          {
            label: '运单号',
            prop: 'waybillNo',
            search: true,
            formatter({ waybillNoListStr }) {
              return waybillNoListStr;
            }
          },
          {
            label: '工单编号',
            prop: 'workOrderNoListStr'
          },
          {
            label: '网点',
            prop: 'serviceNetworkName',
            search: !!this.rowData?.serviceNetworkName,
            searchDefault: this.rowData?.serviceNetworkName || '',
            searchDisabled: true,
            hide: true
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  @media (max-width: 1400px) {
    max-width: 42px;
  }
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .el-select .el-tag__close.el-icon-close {
  top: -7px;
  right: -4px;
}
</style>
